import { query } from '@warp-drive/utilities/json-api';
import { CONTRACT_HEADER } from '../handlers/type-normalization-handler.ts';
import type { EmployeePaymentHistory } from '../data/resources/employee-payment-history.type.ts';

const RESOURCE_PATH = 'api/v2/employee-payment-histories';

export interface EmployeePaymentHistoryQueryOptions {
  page?: {
    number?: number;
    size?: number;
  };
  sort?: string;
}

/**
 * Read an employee's combined accounting and paid external-benefit history
 * from the v2 kit (canceled and failed rows are excluded server-side). The
 * document carries links-based pagination, meta.page, and meta.summary
 * (total cents plus per-servicer breakdown) over the whole filtered set.
 */
export function employeePaymentHistoryQuery(
  employeeId: string,
  options: EmployeePaymentHistoryQueryOptions = {}
) {
  const params: Record<string, string | number> = {
    // Dasherized: the kit controller permits `filter[employee-id]` and refuses
    // a request without it.
    'filter[employee-id]': employeeId,
  };

  if (options.page?.number !== undefined) {
    params['page[number]'] = options.page.number;
  }
  if (options.page?.size !== undefined) {
    params['page[size]'] = options.page.size;
  }
  if (options.sort) {
    params.sort = options.sort;
  }

  const request = query<EmployeePaymentHistory>('employee-payment-history', params, {
    resourcePath: RESOURCE_PATH,
  });

  // The kit serves only its target contract; declaring it keeps the request
  // pipeline's jsonapi-resources rewrites off this call and has the response
  // pipeline camelize the dasherized wire keys into the schema's fields.
  const headers = new Headers(request.headers);
  headers.set(CONTRACT_HEADER, '2');

  return { ...request, headers };
}
